import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var baseMarkerBorderStyle = {
  borderStyle: 'solid',
  borderWidth: '2'
};
var getMarkerStyles = function getMarkerStyles(backgroundColor, textColor) {
  var borderColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return {
    markerStyle: _objectSpread({
      backgroundColor: backgroundColor || undefined,
      borderColor: borderColor || undefined
    }, borderColor && baseMarkerBorderStyle),
    markerContentStyle: {
      textColor: textColor
    }
  };
};
var getStaticMarkerStyle = function getStaticMarkerStyle(hierarchy) {
  switch (hierarchy) {
    case 'secondary':
      return getMarkerStyles(undefined, 'base.intent', 'base.intent.strong');
    case 'tertiary':
      return getMarkerStyles(undefined, 'base.intent');
    case 'primary':
    default:
      return getMarkerStyles('base.intent', 'base.inverted');
  }
};
var getDynamicMarkerStyle = function getDynamicMarkerStyle(state, content) {
  switch (state) {
    case 'past':
    case 'future':
      return getMarkerStyles(undefined, 'state.inactive', content ? 'state.inactive.subtle' : 'state.inactive');
    case 'current':
    default:
      return getMarkerStyles('base.intent', 'base.inverted');
  }
};
var getProgressionMarkerStyle = function getProgressionMarkerStyle(state, content) {
  switch (state) {
    case 'past':
    case 'current':
    default:
      return getMarkerStyles('base.intent', 'base.inverted');
    case 'future':
      return getMarkerStyles(undefined, 'state.inactive', content ? 'state.inactive.subtle' : 'state.inactive');
  }
};
var getMarkerContentStyle = function getMarkerContentStyle(type, hierarchy, state, content) {
  if (type === 'dynamic') {
    return getDynamicMarkerStyle(state, content).markerContentStyle;
  }
  if (type === 'progression') {
    return getProgressionMarkerStyle(state, content).markerContentStyle;
  }
  return getStaticMarkerStyle(hierarchy).markerContentStyle;
};
var getMarkerSize = function getMarkerSize(size) {
  var sizes = {
    l: {
      height: '24px',
      minHeight: '24px',
      minWidth: '24px'
    },
    s: {
      height: '16px',
      minHeight: '16px',
      minWidth: '16px'
    },
    xs: {
      height: '10px',
      minHeight: '10px',
      minWidth: '10px'
    },
    default: {
      height: '20px',
      minHeight: '20px',
      minWidth: '20px'
    }
  };
  if (!size) return sizes.default;
  return sizes[size] || sizes.default;
};
var getMarkerIconSize = function getMarkerIconSize(size, hierarchy) {
  var sizeMapping = {
    tertiary: {
      s: '16',
      default: '20',
      l: '24'
    },
    default: {
      s: '10',
      default: '12',
      l: '14'
    }
  };
  var hierarchyKey = hierarchy === 'tertiary' ? 'tertiary' : 'default';
  if (!size || size === 'xs') return sizeMapping[hierarchyKey].default;
  return sizeMapping[hierarchyKey][size] || sizeMapping[hierarchyKey].default;
};
var getMarkerTypographySize = function getMarkerTypographySize(size) {
  var sizeMapping = {
    s: 'caption-default-strong',
    default: 'caption-default-strong',
    l: 'body-s-strong'
  };
  if (!size || size === 'xs') return 'caption-default-strong';
  return sizeMapping[size] || 'caption-default-strong';
};
var getFinalMarkerContent = function getFinalMarkerContent(size, content) {
  var contentDigits = size === 'l' ? 2 : 1;
  return content.length > contentDigits ? content.substring(0, contentDigits) : content;
};

export { getDynamicMarkerStyle, getFinalMarkerContent, getMarkerContentStyle, getMarkerIconSize, getMarkerSize, getMarkerTypographySize, getProgressionMarkerStyle, getStaticMarkerStyle };
//# sourceMappingURL=Marker.helpers.js.map
